import { memo } from 'react';

import dayjs from 'dayjs';

import { cn } from '@/lib/utils';

import { CELL_GROUP_HEIGHT_PX } from '../../constants';

interface GroupCellShellProps {
  date: dayjs.Dayjs;
  cellWidth: number;
}

/**
 * Lightweight shell cell for group rows — just border/background, no tooltip or text.
 * Rendered synchronously during the initial mount phase before full content is ready.
 */
export const GroupCellShell = memo(({ date, cellWidth }: GroupCellShellProps) => {
  const isToday = date.isSame(dayjs(), 'day');
  const isWeekend = date.day() === 0 || date.day() === 6;
  const isLastDayOfMonth = date.endOf('month').isSame(date, 'day');

  return (
    <div
      className={cn('relative overflow-hidden border-b border-r', {
        'pointer-events-none bg-muted/50': isWeekend,
        'border-r-2': isLastDayOfMonth,
        'bg-green-50 dark:bg-green-950': isToday,
      })}
      style={{
        width: `${cellWidth}rem`,
        minWidth: `${cellWidth}rem`,
        height: CELL_GROUP_HEIGHT_PX,
      }}
    />
  );
});
